import { render, staticRenderFns } from "./IndexDeleted.vue?vue&type=template&id=4604bedc&"
import script from "./IndexDeleted.vue?vue&type=script&lang=js&"
export * from "./IndexDeleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports